export default __webpack_public_path__ + "static/media/suport1.ca8fccea.jpg";